import React from 'react';
import LaunchContent from '../../components/launch/launch-content';

function Launch() {
  return <LaunchContent />;
}

export default Launch;
